var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "uviod8m2ea",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4a36soueb",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#004CC4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#uviod8m2ea)",
    d: "M24 15.529c0 3.348-2.688 6.06-6.036 6.072H6.06C2.724 21.6 0 18.9 0 15.553v-.012s.007-5.311.017-7.983c.001-.501.577-.782.97-.47 2.85 2.262 7.95 6.386 8.013 6.44.852.683 1.932 1.068 3.036 1.068s2.184-.385 3.036-1.08c.064-.043 5.048-4.044 7.943-6.343.393-.313.972-.032.973.468C24 10.291 24 15.53 24 15.53",
    opacity: 0.4,
    transform: "translate(-1110 -219) translate(0 -201) translate(1091 361) translate(0 55) translate(19 4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4a36soueb)",
    d: "M23.371 3.209C22.332 1.25 20.287 0 18.036 0H6.06C3.81 0 1.764 1.25.725 3.209c-.233.438-.122.984.265 1.293L9.9 11.63c.624.504 1.38.755 2.136.755h.024c.756 0 1.512-.25 2.136-.755l8.91-7.127c.388-.31.498-.855.265-1.293",
    transform: "translate(-1110 -219) translate(0 -201) translate(1091 361) translate(0 55) translate(19 4)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.73826faf2801055f9fe61706d3ced84e.svg";
export { ForwardRef as ReactComponent };